import urlFilter from "../filters/url.filter"

/**  Класс для данных авторизации. */
export class ReferenceData {

  /*
   * Заголовок справки
  */
  public Caption: string = '';

  /*
   * описание справки
  */
  public Description: string = '';

  /*
   * Картинка справки
  */
  public Image: string = '';

  /*
   * Идентификатор операции каталога для справки
  */
  public CatalogId: number = 0;


  constructor(src: any) {
    this.Caption = src.caption ?? '';
    this.Description = src.description ?? '';
    this.Image = urlFilter(src.image ?? '');
    this.CatalogId = src.catalogId ?? 0;
  }
}
